import * as qiniu from 'qiniu-js';
import axios from '@/utils/request';
const qiniuyun = (req: any, name: string) => {
  return new Promise((resolve, reject) => {
    const observer = {
      next(res: any) {
        // 上传进度
        // console.log(res.total.percent);
      },
      error(err: any) {
        console.log(err);
        reject(err);
      },
      complete(res: any) {
        resolve(res);
      },
    };
    const url: string = '/api/getQiniuToken';
    const args = {};
    // 重命名要上传的文件
    // const keyname = req.file.name;
    const keyname = name + req.file.name;
    axios.post(url, args).then((res: any) => {
      const config = {
        useCdnDomain: true, // 表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
        region: qiniu.region.z2, // 七牛云的地址, 我建立的是华南区,每个区 不一样,看文档  看自己所在区域
      };
      const token = res.data;
      const putExtra = {
          fname: keyname,
          params: {},
      };
      const observable = qiniu.upload(req.file, keyname, token, putExtra, config);
      const subscription = observable.subscribe(observer); // 上传开始
    }).catch((err: any) => {
      reject(err);
    });
  });
};
export default qiniuyun;
